
<div class="ed-crisp-chat-placeholder" *ngIf="showPreview">
  <div class="ed-crisp-chat-circle" (click)="toggle()">
    <div class="ed-crisp-chat--icon"></div>
  </div>

  <div class="ed-crisp-description" *ngIf="show">
    <div class="ed-crisp-description-head" i18n>
      Unser Support-Chat wird über den Dienst "Crisp" bereitgestellt.
      Zur Nutzung des Support-Chats benötigen wir deine Zustimmung
    </div>
    <a target="_blank" href="https://crisp.chat/de/privacy/" class="ed-crisp-description-privacy" i18n>
      Datenschutz von Crisp
    </a>
    <div
      edButton
      class="ed-crisp-description-toggle"
      (click)="loadAndOpen()" i18n
    >Zustimmen & Chat laden</div>
  </div>
</div>
